import {MinimalProperty, Property} from "../../contexts/properties/logic";
import {AppConfig} from "../../hooks/useConfig";
import {BudgetingType} from "../../BudgetingType";
import {getMonthIndexes, getMonths} from "../../utils/months-helper";

export function getYear(
    property: MinimalProperty | undefined,
    config: AppConfig,
    tab: BudgetingType
): number {
    let year = config.year;
    if(property){
        if(property.isAcquisitionProperty && property.acquisitionBudgetYear){
            return property.acquisitionBudgetYear;
        }
        year = property.reforecastYear;
    }

    return tab == BudgetingType.REFORECAST ? year : year + 1;
}

function getYears(monthIndices: number[], year: number): number[] {
    const vals = new Array(monthIndices.length).fill(year);
    if(monthIndices[0] === 0) {
        return vals;
    }
    let incr = 0;
    for(let i = 0; i < monthIndices.length; i++){
        if(monthIndices[i] === 0){
            incr++;
        }
        vals[i] += incr;
    }
    return vals;
}

export function getMonthYears(property: Property | undefined, year: number): [string[], number[]] {
    const months = getMonths(property);
    const indices = getMonthIndexes(property);
    const vals = getYears(indices, year);
    return [months, vals];
}

export function getMonthIndicesAndYears(property: Property | undefined, year: number): [number[], number[]] {
    const months = getMonthIndexes(property);
    const vals = getYears(months, year);
    return [months, vals];
}